export default __webpack_public_path__ + "static/media/lorry_active.bc3841fb.svg";